import { FETCH_WIDGETS_REQUEST } from '../../types'

export default function requestAction() {
  return { type: FETCH_WIDGETS_REQUEST }
}
